// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CurveLinearIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CurveLinearIcon" ref={forwardedRef} {...props}>
      <path d="m10.125 5.002 8.249 8.384-1.248 1.228-7.001-7.116-7.001 7.116-1.248-1.228z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CurveLinearIcon = /* @__PURE__ */ Object.assign(
  CurveLinearIconComponent,
  { displayName: 'CurveLinearIcon' },
);
